// src/services/savedQuestionService.ts
// ✅ CORRIGIDO: rotas alinhadas com savedQuestionRoutes.js

const API_BASE_URL = '/api';

class SavedQuestionService {
    private getHeaders(): HeadersInit {
        const token = localStorage.getItem('accessToken');
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        };
    }

    // ── Listar questões salvas ───────────────────────────────
    async getSavedQuestions(params?: { category?: string; tags?: string; page?: number; limit?: number }) {
        const query = new URLSearchParams();
        if (params?.category) query.append('category', params.category);
        if (params?.tags) query.append('tags', params.tags);
        if (params?.page) query.append('page', String(params.page));
        if (params?.limit) query.append('limit', String(params.limit));

        const response = await fetch(
            `${API_BASE_URL}/saved-questions?${query.toString()}`,
            { headers: this.getHeaders() }
        );

        if (!response.ok) throw new Error('Erro ao buscar questões salvas');
        return response.json();
    }

    // ── Salvar questão ───────────────────────────────────────
    async saveQuestion(questionId: string, notes?: string, tags?: string[]) {
        const response = await fetch(
            `${API_BASE_URL}/saved-questions/${questionId}`,
            {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({ notes: notes || null, tags: tags || [] })
            }
        );

        // 400 com alreadySaved = true não é erro crítico
        if (response.status === 400) {
            const data = await response.json();
            if (data.alreadySaved) return data;
        }

        if (!response.ok) throw new Error('Erro ao salvar questão');
        return response.json();
    }

    // ── Remover questão ──────────────────────────────────────
    async removeQuestion(questionId: string) {
        const response = await fetch(
            `${API_BASE_URL}/saved-questions/${questionId}`,
            { method: 'DELETE', headers: this.getHeaders() }
        );

        if (!response.ok) throw new Error('Erro ao remover questão');
        return response.json();
    }

    // ✅ Verificar se está salvo — rota correta: /check/:questionId
    async checkIfSaved(questionId: string): Promise<boolean> {
        try {
            const response = await fetch(
                `${API_BASE_URL}/saved-questions/check/${questionId}`,
                { headers: this.getHeaders() }
            );

            if (!response.ok) return false;
            const data = await response.json();
            return data.isSaved === true;
        } catch {
            return false;
        }
    }

    // ── Atualizar anotações ──────────────────────────────────
    async updateNotes(questionId: string, notes: string, tags?: string[]) {
        const response = await fetch(
            `${API_BASE_URL}/saved-questions/${questionId}`,
            {
                method: 'PUT',
                headers: this.getHeaders(),
                body: JSON.stringify({ notes, tags })
            }
        );

        if (!response.ok) throw new Error('Erro ao atualizar anotações');
        return response.json();
    }

    // ── Estatísticas do caderno ──────────────────────────────
    async getStats() {
        const response = await fetch(
            `${API_BASE_URL}/saved-questions/stats/summary`,
            { headers: this.getHeaders() }
        );

        if (!response.ok) throw new Error('Erro ao buscar estatísticas');
        return response.json();
    }
}

export const savedQuestionService = new SavedQuestionService();